<template>
  <v-col cols="12" xs="12" v-if="longDescription">
    <v-expansion-panels v-model="panel" multiple focusable flat accordion>
      <v-expansion-panel v-for="(item,i) in items" :key="i">
        <v-expansion-panel-header>Product Description</v-expansion-panel-header>
        <v-expansion-panel-content class="mt-4">{{longDescription}}</v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-col>
</template>

<script>
export default {
  props: {
    product: null
  },

  data: () => {
    return {
      items: 1,
      panel: [0]
    };
  },

  beforeMount() {
    this.checkAutoExpand();
  },

  computed: {
    longDescription() {
      if (this.product.long_description != "") {
        return this.product.long_description;
      }
      return false;
    }
  },

  methods: {
    checkAutoExpand() {
      console.log("-- Checking Auto Expand");
      if (!this.$vuetify.breakpoint.lgAndUp) {
        console.log("-- Mobile");
        this.panel = [];
      }
    }
  }
};
</script>

<style lang="sass" scoped>
.v-expansion-panel
  border: 1px solid rgb(232, 232, 232)
</style>